const careProvidedData = [
  {
    group_title: "Care Provided",
    group_items: [
      {
        title: "Type of Service",
        checked: false,
        type: "dropdown",
        value: "",
        key: "type_of_service",
        dropdown_list: [
          "Care Home with nursing - Privately Owned",
          "Registered for a maximum of 48 Service Users",
        ],
      },
      {
        title: "Registered Care Categories",
        checked: false,
        type: "dropdown",
        value: "",
        key: "registered_care_categories",
        dropdown_list: [
          "Dementia",
          "Old Age",
          "Physical Disability",
          "Younger Adults",
        ],
      },
      {
        title: "Specialist Care Categories",
        checked: false,
        type: "dropdown",
        value: "",
        key: "specialist_care_categories",
        dropdown_list: [
          "AIDS/HIV",
          "Alzheimer's",
          "Cancer Care",
          "Colitis & Crohn's Disease",
          "Epilepsy",
          "Head/Brain Injury",
          "Hearing Impairment",
          "Huntington's Disease",
          "Motor Neurone Disease",
          "Multiple Sclerosis",
          "Parkinson's Disease",
        ],
      },
      {
        title: "Other Care Provided",
        checked: false,
        type: "dropdown",
        value: "",
        key: "other_care_provided",
        dropdown_list: [
          "Convalescent Care",
          "Respite Care",
          "Day Care",
          "Palliative Care",
        ],
      },
    ],
  },
];

const goodToKnowData = [
  {
    group_title: "Good to Know",
    group_items: [
      {
        title: "Group/Owner",
        checked: false,
        type: "text",
        value: "",
        key: "group_owner",
      },
      {
        title: "Person in charge",
        checked: false,
        type: "text",
        value: "",
        key: "person_in_charge",
      },
      {
        title: "Local Authority / Social Services",
        type: "text",
        checked: false,
        value: "",
        key: "local_authority_social_service",
      },
      {
        title: "Admission Restrictions",
        checked: false,
        type: "text",
        value: "",
        key: "addmission_restrictions",
      },
      {
        title: "Languages Spoken by Staff",
        checked: false,
        type: "text",
        value: "",
        key: "languages_spoken_by_staff",
      },
    ],
  },
];

const fundingFeesGuideData = [
  {
    group_title: "Funding and Fees Guide",
    group_items: [
      {
        title: "Local Authority Funding",
        checked: false,
        type: "checkbox",
        value: "",
        key: "local_authority_funding",
      },
      {
        title: "Local Authority Funding & Top Up",
        checked: false,
        type: "checkbox",
        value: "",
        key: "local_authority_funding_top_up",
      },
      {
        title: "Funding",
        checked: false,
        type: "checkbox",
        value: "",
        key: "funding",
      },
      {
        title: "Private/Self Funding",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
    ],
  },
  {
    group_title: "Weekly Charges per Person",
    group_items: [
      {
        title: "weekly Charges per Person",
        checked: false,
        type: "dropdown",
        value: "",
        key: "weekly_charges_per_person",
        dropdown_list: [
          "Self-Funded Residential Care from £995",
          "Self-Funded Residential Dementia Care from £995",
          "Self-Funded Nursing Care from £995",
          "Self-Funded Nursing Dementia Care from £995",
        ],
      },
    ],
  },
];

const facilitiesData = [
  {
    group_title: "Facilities",
    group_items: [
      {
        title: "Close to Local shops",
        checked: false,
        type: "checkbox",
        value: "",
        key: "local_authority_funding",
      },
      {
        title: "Gardens for residents",
        checked: false,
        type: "checkbox",
        value: "",
        key: "local_authority_funding_top_up",
      },
      {
        title: "Lift",
        checked: false,
        type: "checkbox",
        value: "",
        key: "funding",
      },
      {
        title: "Minibus or other transport",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
      {
        title: "Near Public Transport",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
      {
        title: "Own Furniture if required",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
      {
        title: "Pets by arrangement",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
      {
        title: "Phone Point in own room/Mobile",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
      {
        title: "Television point in own room",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
      {
        title: "Wheelchair access",
        checked: false,
        type: "checkbox",
        value: "",
        key: "private_self_funding",
      },
    ],
  },
];

const PageJSONType = [
  {
    page_title: "About",
    key: "page_about",
    group_items: [
      {
        group_title: "Welcome",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Our Independent Advisors",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Our Kind Care Leadership",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
          },
        ],
      },
      {
        group_title: "Our Kind Care Experts",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
          },
        ],
      },
    ],
  },
  {
    page_title: "Kind Care",
    key: "page_kind_care",
    group_items: [
      {
        group_title: "Caring through the pandemic",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Visiting our care homes",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Support for professionals",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Planning Care Admissions",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Keeping You Safe",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Types Of Care",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Wellbeing",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Food and Dining",
        group_description: "",
        has_image: false,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
    ],
  },
  {
    page_title: "Location",
    key: "page_location",
    group_items: [
      {
        group_title: "Care Categories",
        has_image: true,
        group_sections: [
          {
            title: "",
            image: "",
          },
        ],
      },
      {
        group_title: "Care Packages",
        has_image: true,
        group_sections: [
          {
            title: "",
            image: "",
          },
        ],
      },
      {
        group_title: "Home features",
        has_image: true,
        group_sections: [
          {
            title: "",
            image: "",
          },
        ],
      },
      {
        group_title: "Specialist care categories",
        has_image: true,
        group_sections: [
          {
            title: "",
            image: "",
          },
        ],
      },
    ],
  },
  {
    page_title: "Join The Team",
    key: "page_join_the_team",
    group_items: [
      {
        group_title: "What Our Colleagues Say",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
          },
        ],
      },
    ],
  },
  {
    page_title: "FAQ's",
    key: "page_faqs",
    group_items: [
      {
        group_title: "FAQ's",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
          },
        ],
      },
    ],
  },
  {
    page_title: "Life",
    key: "page_life",
    group_items: [
      {
        group_title: "Activities",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
            address: "",
            video_url: "",
          },
        ],
      },
      {
        group_title: "Food and Drink",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
          },
        ],
      },
      {
        group_title: "Healthcare",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
          },
        ],
      },
      {
        group_title: "Health & Fitness",
        group_description: "",
        has_image: true,
        group_sections: [
          {
            title: "",
            description: "",
            image: "",
            role: "",
          },
        ],
      },
    ],
  },
];

const GenericSection = {
  page_title: "",
  sections: [
    {
      has_section_heading: false,
      section_heading: "",

      has_section_subheading: false,
      section_subheading: "",

      has_section_description: false,
      section_description: "",

      has_section_image: false,
      section_image: "",

      has_files: false,
      files: [],

      section_type: "", // List, gallery, widget, location
      section_listing_type: "", // row, accordion, tab, list

      has_custom_icon: false,

      icon_color: "",
      custom_icon: "",

      items: [],

      location_list: [],
    },
  ],
};
const ItempJSON = {
  has_item_heading: false,
  item_heading: "",

  has_item_short_description: false,
  item_short_description: "",

  has_item_description: false,
  item_description: "",

  has_item_image: false,
  item_image: "",

  has_item_role: false,
  item_role: "",

  has_item_video: false,
  item_video: "",

  has_item_address: false,
  item_address: "",

  has_item_widget: false,
  item_widget: "",

  has_item_custom_icon: false,
  item_custom_icon: "",

  item_location_id: "",
};

const GenericSectionCheckBox = [
  { title: "Heading", key: "has_section_heading" },
  { title: "Sub Heading", key: "has_section_subheading" },
  { title: "Description", key: "has_section_description" },
  { title: "Image", key: "has_section_image" },
  { title: "Files", key: "has_files" },
];
const GenericItemCheckBox = [
  { title: "Heading", key: "has_item_heading" },
  { title: "Short Description", key: "has_item_short_description" },
  { title: "Description", key: "has_item_description" },
  { title: "Image", key: "has_item_image" },
  { title: "Role", key: "has_item_role" },
  { title: "Video URL", key: "has_item_video" },
  { title: "Address", key: "has_item_address" },
  { title: "Widget", key: "has_item_widget" },
  { title: "Custom Icon", key: "has_item_custom_icon" },
];
const GroupTypes = [
  "None",
  "List",
  "Facilities (Images)",
  "Facilities (Icons)",
  "Location",
  "Gallery",
  "Widget",
  "Files",
  "Team",
];
const GenericGroup = [];
const GroupListingTypes = ["Row", "Tab", "Accordion"];
const LocationListingTypes = ["Single View", "Grid View"];

const LocationPagesList = [
  {
    page_title: "About",
    key: "page_about",
  },
  {
    page_title: "Kind Care",
    key: "page_kind_care",
  },
  {
    page_title: "Location",
    key: "page_location",
  },
  {
    page_title: "Join The Team",
    key: "page_join_the_team",
  },
  {
    page_title: "FAQ's",
    key: "page_faqs",
  },
  {
    page_title: "Life",
    key: "page_life",
  },
];

const PageTypes = ["General", "Location"];

const TypeOfCare = [
  "Dementia",
  "Old Age",
  "Physical Disability",
  "Younger Adults",
];
const CTATypes = ["Button", "Link"];
const InnerSectionCheckBox = [
  { title: "Heading", key: "has_section_heading" },
  { title: "Sub Heading", key: "has_section_subheading" },
  { title: "Description", key: "has_section_description" },
  { title: "Image", key: "has_section_image" },
  { title: "Files", key: "has_files" },
  { title: "Call To Actions", key: "has_section_cta" },
];
const ListColumnTypes = ["List", "List With Images", "List With Icons"];
const ColumnCount = ["1", "2", "3"];

const EventType = ["News", "Blog", "Event"];

const rawEmailSettings = {
  email: {
    general: [
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
    ],
    care: [
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
    ],
    job: [
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
    ],
    tour: [
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
      {
        value: "",
        error: "",
      },
    ],
  },
};

const emailType = ["general", "care", "job", "tour"];

const locationStepper = {
  overview: [
    "description",
    "brand_name",
    "purpose_built",
    "bed_vacancies",
    "nearby_bus_stop",
    "nearby_local_pub",
    "nearby_train",
    "nearby_shops",
    "id",
    "all_inclusive",
    "ensuite",
    "ensuite_coverage",
    "opening_date",
  ],
  media: ["logo", "images", "video", "id"],
  care: [
    "activities",
    "additional_elderly_care_option",
    "care_facilities",
    "id",
  ],
  team: ["team", "id"],
  faqs: ["faqs"],
};

const locationSteps = {
  overview: {
    next: "media",
    prev: "",
    progress: 20,
  },
  media: {
    next: "care",
    prev: "overview",
    progress: 40,
  },
  care: {
    next: "team",
    prev: "media",
    progress: 60,
  },
  team: {
    next: "faqs",
    prev: "care",
    progress: 80,
  },
  faqs: {
    next: "summary",
    prev: "team",
    progress: 100,
  },
};

let staticFacilities = [
  "Bar/Cafe",
  "Gardens",
  "Flexible mealtimes",
  "Activity room",
  "Furnished rooms",
  "Electric profiling beds",
  "Lift",
  "Nurse call system",
  "Call Bells",
  "Minibus or other transport",
  "Assisted Bathroom",
  "Daily Newspapers",
  "Dining Room",
  "En-Suite Rooms",
  "Hair Salon",
  "Kitchenette",
  "Meals in Bedroom if Required",
  "Pets by Arrangement",
  "Premier Rooms",
  "Pub",
  "Resident Choice Menus",
  "TV Point",
  "Wet Rooms",
  "Wi-Fi",
  "Designated Smoking Area",
  "Dry Cleaning by Arrangements",
  "Lounge",
  "Outdoor area",
  "Post",
  "Protected Mealtimes",
  "Public Transport",
  "Quiet Room",
  "Sensory Room",
  "Hairdressing",
  "Single Rooms",
  "Wellbeing",
  "Wheelchair Access",
  "On-site Chapel or Prayer Room",
  "Therapy Room",
  "Fitness or Exercise Rooms",
  "Library or Reading Areas",
  "Cinema or Movie Rooms",
  "Therapy Pool or Hydrotherapy Facilities",
  "Outdoor Seating Areas",
  "Visitor Areas",
  "Secure Entry Systems",
];

export {
  careProvidedData,
  goodToKnowData,
  fundingFeesGuideData,
  facilitiesData,
  LocationPagesList,
  PageTypes,
  PageJSONType,
  TypeOfCare,
  GroupTypes,
  GenericGroup,
  GenericSection,
  GroupListingTypes,
  GenericSectionCheckBox,
  GenericItemCheckBox,
  LocationListingTypes,
  ItempJSON,
  CTATypes,
  InnerSectionCheckBox,
  ListColumnTypes,
  ColumnCount,
  EventType,
  rawEmailSettings,
  emailType,
  locationStepper,
  locationSteps,
  staticFacilities,
};
